import React from 'react';
import { Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';

interface DueDateCellProps {
    dueDate: string;
    status: string;
}

export function DueDateCell({ dueDate, status }: DueDateCellProps) {
    const isOverdue = status === 'Overdue';
    const daysOverdue = isOverdue
        ? dayjs().startOf('day').diff(dayjs(dueDate).startOf('day'), 'day')
        : 0;
    return (
        <Stack gap={0}>
            <Text size="sm">{dueDate}</Text>
            {isOverdue && daysOverdue > 0 && (
                <Text size="xs" className="text-red-500">
                    {daysOverdue} {daysOverdue === 1 ? 'Day' : 'Days'} Overdue
                </Text>
            )}
        </Stack>
    );
}
